exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#videoplayer[data-v-8ef35988] {\n  width: 100%;\n  height: 100%;\n  background-color: black;\n  overflow: hidden;\n}\n#video[data-v-8ef35988] {\n  display: block;\n  position: relative;\n\n  margin: auto;\n  /* height: 100%; */\n  width: 100%;\n  max-width: 100%;\n  max-height: 100%;\n}\n", ""]);

// exports
